import config from "@/config";

export function getLocale(): string {
  return config.locale;
}
